import { Button, Flex } from "antd";
import styled from "styled-components";

import { PrimaryText } from "@/shared/ui/Typography";

export const StyledSum = styled(PrimaryText)`
    text-wrap: wrap;

    && {
        color: ${({ theme }) => theme.additionalTypographyColor};
    }
`;

export const StyledCard = styled(Flex)`
    position: relative;
    width: 100%;
    padding: 16px;
    padding-bottom: 8px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    background: ${({ theme }) => theme.collapseHeaderBackground};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const StyledRemoveButton = styled(Button)`
    position: absolute;
    top: 0;
    right: 0;
`;
